import { render, staticRenderFns } from "./VCrud.vue?vue&type=template&id=15961356"
import script from "./VCrud.vue?vue&type=script&lang=js"
export * from "./VCrud.vue?vue&type=script&lang=js"
import style0 from "./VCrud.vue?vue&type=style&index=0&id=15961356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports